import {InlineDatumReactComponentProps} from '@stripe-internal/inline-data';
import {
  useNewUniversalHelpDesign,
  useInlineRacEmailForm,
} from '@stripe-internal/conversations-ui';

import {UniversalHelpChannelMenuLegacy} from './UniversalHelpChannelMenuLegacy';
import {UniversalHelpChannelMenuNew} from './UniversalHelpChannelMenuNew';

export function UniversalHelpChannelMenu(
  props: InlineDatumReactComponentProps,
) {
  const useNewDesign = useNewUniversalHelpDesign();
  const inlineRacEmailForm = useInlineRacEmailForm();

  if (useNewDesign && inlineRacEmailForm) {
    return <UniversalHelpChannelMenuNew {...props} />;
  }

  return <UniversalHelpChannelMenuLegacy {...props} />;
}
